
import { useRef, useEffect } from "react"
import { useEditor } from "../EditorContext"
import SubformInteger from "./Subforms/SubformInteger"
import SubformNumber from "./Subforms/SubformNumber"
import SubformString from "./Subforms/SubformString"
import SubformEnum from "./Subforms/SubformEnum"


function ControlForm({control, formStructure}) {

  const { changeFieldType, updateFieldUiSchema, updateFieldSchema, setEditingElement } = useEditor()

  const inputRef = useRef(null)
  useEffect(() => {
    inputRef.current.focus()
  }, [])

  return (

    <div className='group-editor mt-0 mb-4'>
      <div className='editor-header'>
        <h4 className='editor-header'>
          <button 
            className='btn editor-button me-4'
            onClick={(e) => setEditingElement(undefined)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-check-square" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
              <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
            </svg>
          </button>
          Редактирование поля: {control.scope.slice(2).split('/').pop()}
        </h4>
      </div>
      <div className='editor-content'>
        <form>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label">Имя поля</label>
            <div className="col-sm-8">
              <input
                key={control.id + '_scope'}
                id="scope"
                type="text"
                className="form-control"
                value={control.scope.slice(2).split('/').pop()}
                onChange={(e) => updateFieldUiSchema(formStructure, control.id, e.target)}
                placeholder="имя поля"
                ref={inputRef}
              />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label">Аналит</label>
            <div className="col-sm-8">
              <input
                key={control.id + '_analyte'}
                id="prop_analyte"
                type="text"
                className="form-control"
                value={control.schemaProps.prop_analyte}
                onChange={(e) => updateFieldSchema(formStructure, control.id, e.target)}
                placeholder="аналит"
              />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label">kv</label>
            <div className="col-sm-8">
              <input
                key={control.id + '_kv'}
                id="prop_kv"
                type="text"
                className="form-control"
                value={control.schemaProps.prop_kv}
                onChange={(e) => updateFieldSchema(formStructure, control.id, e.target)}
                placeholder="значение kv"
              
              />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label">section</label>
            <div className="col-sm-8">
              <input
                key={control.id + '_section'}
                id="prop_section"
                type="text"
                className="form-control"
                value={control.schemaProps.prop_section}
                onChange={(e) => updateFieldSchema(formStructure, control.id, e.target)}
                placeholder="значение section"
              
              />
            </div>
          </div>
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label">measure</label>
            <div className="col-sm-8">
              <input
                key={control.id + '_measure'}
                id="prop_measure"
                type="text"
                className="form-control"
                value={control.schemaProps.prop_measure}
                onChange={(e) => updateFieldSchema(formStructure, control.id, e.target)}
                placeholder="значение measure"
              
              />
            </div>
          </div>
          <div className='row mb-3'>
            <label className="col-sm-2 col-form-label">Тип поля</label>
            <div className="col-sm-3">
              <select
                key={control.id + '_type'} 
                id="type" 
                className="lk-select form-select" 
                value={control.schemaProps.type === 'string' && control.schemaProps.enum ? 'enum' : control.schemaProps.type}
                onChange={(e) => changeFieldType(formStructure, control.id, e.target.value)}
              >
                <option value="integer">целое число</option>
                <option value="number">дробное число</option>
                <option value="string">строка</option>
                <option value="enum">выбор варианта</option>
              </select>
            </div>
          </div>          
        </form>

        <hr className='my-4'></hr>

        {control.schemaProps.type === 'integer'?
          <SubformInteger 
            control={control}
            formStructure={formStructure}
          />
        :
          <></>
        }
        {control.schemaProps.type === 'number' ?
          <SubformNumber
            control={control}
            formStructure={formStructure}
          />
        :
          <></>
        }
        {control.schemaProps.type === 'string' ?
          <>
            {control.schemaProps.enum ?
              <SubformEnum 
                control={control}
                formStructure={formStructure}
              /> 
            :
              <SubformString 
                control={control}
                formStructure={formStructure}
              />
            }  
          </>
        :
          <></>
        }      
      </div>
    </div>    
  )
}

export default ControlForm